import Figure from "~/components/figure"

const highlightColor = `rgba(228, 118, 88, 0.9)`
export default class FeatureVisualization extends Component {
  state = { activeNeuron: null }

  componentWillMount() {
    const { data } = this.props
    this.setState({ activeNeuron: Object.keys(data)[0] })
  }

  render() {
    const { activeNeuron } = this.state
    const { data } = this.props
    const neurons = Object.keys(data)
    const w = 100
    const wDiverse = 155

    return (
      <Figure>
        <Surface marginY={20}>
          <Surface marginLeft={40} marginBottom={6} flexFlow="row">
            <Text fontSize={22} fontWeight={600}>
              Feature Visualization With Diversity
            </Text>
            <Text fontSize={22} fontWeight={600} opacity={0.7} marginLeft={215}>
              3b:{activeNeuron}
            </Text>
          </Surface>
          <Surface flexFlow="row" alignItems="flex-start">
            <Surface
              flexFlow="row"
              alignItems="center"
              marginX={10}
              width={700}
            >
              <Surface>
                <Surface flexFlow="row" flexWrap="wrap">
                  {activeNeuron &&
                    data[activeNeuron].map(img => (
                      <Surface margin={10} overflow="hidden" borderRadius={5}>
                        <img width={wDiverse} src={img} />
                      </Surface>
                    ))}
                </Surface>
                <Text
                  fontSize={20}
                  marginTop={5}
                  width={660}
                  lineHeight={1.3}
                  alignSelf="center"
                  textAlign="center"
                >
                  Even when optimized for diversity, feature visualizations of
                  curve neurons have similar angles. However, they have a
                  variety of colors and textures.
                </Text>
              </Surface>
            </Surface>
            <Surface
              flexFlow="row"
              flexWrap="wrap"
              width={600}
              marginX={10}
              marginTop={5}
            >
              {neurons.map(neuron => (
                <Surface
                  margin={5}
                  onMouseEnter={() => this.setState({ activeNeuron: neuron })}
                >
                  <Surface
                    overflow="hidden"
                    borderRadius={5}
                    style={{
                      transition: "all 300ms ease-out",
                      border: `2px solid ${
                        activeNeuron === neuron ? highlightColor : "transparent"
                      }`,
                    }}
                  >
                    <img
                      width={w}
                      src={neuronFeatureVis("inceptionv1", "mixed3b", neuron)}
                    />
                  </Surface>
                </Surface>
              ))}
            </Surface>
          </Surface>
        </Surface>
      </Figure>
    )
  }
}
